import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../components/ui/select.tsx';

const environments = [
  { value: 'development', label: 'Development' },
  { value: 'production', label: 'Production' },
] as const;

interface EnvironmentSelectorProps {
  value: string;
  onChange: (env: string) => void;
}

export function EnvironmentSelector({ value, onChange }: EnvironmentSelectorProps) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className='w-[180px]'>
        <SelectValue placeholder='Select environment' />
      </SelectTrigger>
      <SelectContent>
        {environments.map((env) => (
          <SelectItem
            key={env.value}
            value={env.value}
            className={env.value === 'production' ? 'text-destructive focus:text-destructive' : ''}
          >
            {env.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
